import { getIn } from 'fun-util';
import ModalTypeEnum from '../../src-react/Modals/ModalConstants';
import FreeWriteBuilderModalEnum from '../../src-react/FreeWriteBuilderModals/FreeWriteBuilderModalConstants';

const ReactCompatibility = {
  documentSettingsInitialized(documentSettings) {
    return window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.documentSettingsInitialized(documentSettings),
    );
  },

  getDocumentContentToSave() {
    return window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.getDocumentContentToSave(),
    );
  },

  getDocumentShareContentToSave() {
    return window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.getDocumentShareContentToSave(),
    );
  },

  getDefaultDragAndDropDisabled() {
    const state = window.FormSwift.React.store.getState();
    return state.UploadHandler.defaultDropTrackingDisabled;
  },

  disableDefaultDragAndDropTracking() {
    return window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.disableDefaultDragAndDropTracking(),
    );
  },

  enableDefaultDragAndDropTracking() {
    return window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.enableDefaultDragAndDropTracking(),
    );
  },

  getState() {
    return window.FormSwift.React.store.getState();
  },
  getZIndexPopup() {
    const state = window.FormSwift.React.store.getState();
    return state.popupHandler.zIndex;
  },
  setZIndexPopup(zIndex) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.setZIndexPopup(zIndex),
    );
  },
  clearActivePopup() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.clearActivePopup(),
    );
  },
  createCheckboxPopup(
    x = 0,
    y = 0,
    width = 28,
    height = 28,
    pageIdx = window.getPageIndex(),
    checked = false,
    disabled = false,
  ) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.createCheckboxPopup(
        x,
        y,
        width,
        height,
        pageIdx,
        checked,
        disabled,
      ),
    );
  },
  createTextPopup({
    x = 0,
    y = 0,
    width = 12,
    height = 28,
    pageIdx = window.getPageIndex(),
    text = '',
    bold = false,
    italic = false,
    fontFamily = 'Arial',
    fontSize = 17,
    color = '#000000', // Needs to be 6 digits on the backend
    draggable = true,
    disabled = false,
    backgroundColor = null,
  }) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.createTextPopup({
        x,
        y,
        width,
        height,
        pageIdx,
        text,
        bold,
        italic,
        fontFamily,
        fontSize,
        color,
        draggable,
        disabled,
        backgroundColor,
      }),
    );
  },
  setRulerActive(active) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.setRulerActive(active),
    );
  },
  initEditorMode(mode) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.setEditorMode(mode, false),
    );
  },
  setEditorMode(mode, persist = true) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.setEditorMode(mode, persist),
    );
  },
  updateEditorMode(mode, persist = true) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.updateEditorMode(mode, persist),
    );
  },
  enableSign(persist = true) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.enableSign(persist),
    );
  },
  enableEdit(persist = true) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.enableEdit(persist),
    );
  },
  enableView(persist = true) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.enableView(persist),
    );
  },
  enableRequestSignature(persist = true) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.enableRequestSignature(persist),
    );
  },
  enableRequestSignatureWait(persist = true) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.enableRequestSignatureWait(persist),
    );
  },
  enableRequestSignatureFill() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.enableRequestSignatureFill(),
    );
  },
  enableSenderSigning(persist = true) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.enableSenderSigning(persist),
    );
  },

  unwrapRequestSignaturePopups() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.unwrapRequestSignaturePopups(),
    );
  },
  showSignatureDeclineToolbar() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.showSignatureDeclineToolbar(),
    );
  },

  createRequestSignaturePopup(
    requestType,
    x,
    y,
    width,
    height,
    pageIdx,
    draggable,
    disabled,
    resizable,
    requestSettings,
    contentSettings,
  ) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.createRequestSignaturePopup(
        requestType,
        x,
        y,
        width,
        height,
        pageIdx,
        draggable,
        disabled,
        resizable,
        requestSettings,
        contentSettings,
      ),
    );
  },
  createImagePopup(src, imgIdx, pageIdx, width, x, y) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.createImgPopup(
        src,
        imgIdx,
        pageIdx,
        width,
        x,
        y,
      ),
    );
  },
  createLogoPopup(src, imgIdx, width, x, y) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.createLogoPopup(
        src,
        imgIdx,
        width,
        x,
        y,
      ),
    );
  },
  createResizablePopup(src, type, imgIdx, pageIdx, width, height, x, y) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.createResizablePopup(
        src,
        type,
        imgIdx,
        pageIdx,
        width,
        height,
        x,
        y,
      ),
    );
  },
  createSignaturePopup(src, imgIdx, pageIdx, width, x, y) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.createSigPopup(
        src,
        imgIdx,
        pageIdx,
        width,
        x,
        y,
      ),
    );
  },
  deletePopup(id) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.deletePopup(id),
    );
  },
  deleteSharePopups() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.deleteSharePopups(),
    );
  },
  movePopup(popupID, x, y) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.movePopup(
        popupID,
        x,
        y,
      ),
    );
  },
  updatePopup(popupID, updatedAttributes) {
    if (!popupID) return;
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.changePopup(
        popupID,
        updatedAttributes,
      ),
    );
  },
  updateRequestSignaturePopupContentSettings(popupID, updatedAttributes) {
    const reactState = ReactCompatibility.getState();
    const popupData = reactState.popupHandler.popups[popupID];
    const mergedAttributes = { ...popupData.contentSettings, ...updatedAttributes };

    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.changePopup(
        popupID,
        {
          contentSettings: mergedAttributes,
        },
      ),
    );
  },
  showDownloadOverlay() {
    window.FormSwift.React.store.dispatch(
      window.window.FormSwift.React.actions.showDownloadOverlay(),
    );
  },
  openStaticSecondActionModal() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.openStaticSecondActionModal(),
    );
  },
  openSignatureManager(fromPopupID = null) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.loadPopupIdToSignatureManager(
        fromPopupID,
      ),
    );
  },
  closeSignatureManager() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.hideFreeWriteSignatureSection(),
    );
  },
  savePopupAsSignature(popupID, textVal) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.savePopupAsSignature(popupID, textVal),
    );
  },
  selectDocumentSession(sessionId, documentType, documentName, key) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.selectDocumentSession(
        sessionId,
        documentType,
        documentName,
        key,
      ),
    );
  },
  deselectDocumentSession(sessionId) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.deselectDocumentSession(sessionId),
    );
  },
  editDocumentName(sessionListIndex, documentName) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.editDocumentName(sessionListIndex, documentName),
    );
  },
  toggleHelpSideBar() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.toggleHelpSideBar(),
    );
  },
  openFreeWriteLoadingDocumentModal() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.openModal(ModalTypeEnum.FREE_WRITE_LOADING_DOCUMENT),
    );
  },
  closeFreeWriteLoadingDocumentModal() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.closeModal(ModalTypeEnum.FREE_WRITE_LOADING_DOCUMENT),
    );
  },
  finishFreeWriteLoadingDocumentModal(callback = null) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.finishModal(ModalTypeEnum.FREE_WRITE_LOADING_DOCUMENT),
    );

    if (callback) {
      callback();
    }
  },
  openFreeWriteDocumentReadyOnboardingModal() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.openFreeWriteOnboardingModal(
        FreeWriteBuilderModalEnum.DOCUMENT_READY_FREEWRITE_MODAL,
      ),
    );
  },
  closeFreeWriteDocumentReadyModal() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.closeModal(ModalTypeEnum.FREE_WRITE_DOCUMENT_READY),
    );
  },
  openFreeWriteExportDocumentModal(format) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.openFreeWriteExportDocumentModal(format),
    );
  },
  closeFreeWriteExportDocumentModal() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.closeModal(ModalTypeEnum.FREE_WRITE_EXPORT_DOCUMENT),
    );
  },
  openFreeWriteDocumentShareModal() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.openModal(ModalTypeEnum.FREE_WRITE_DOCUMENT_SHARE),
    );
  },
  expandFreeWriteDocumentSignatureSection() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.expandFreeWriteSignatureSection(),
    );
  },
  openFreeWriteEraserOnboardingModal() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.openFreeWriteOnboardingModal(
        FreeWriteBuilderModalEnum.ERASER_FREEWRITE_MODAL,
      ),
    );
  },
  openFreeWriteHighlighterOnboardingModal() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.openFreeWriteOnboardingModal(
        FreeWriteBuilderModalEnum.HIGHLIGHTER_FREEWRITE_MODAL,
      ),
    );
  },
  openFreeWriteRedactOnboardingModal() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.openFreeWriteOnboardingModal(
        FreeWriteBuilderModalEnum.REDACT_FREEWRITE_MODAL,
      ),
    );
  },
  openFreeWriteSignatureCancelModal() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.openModal(ModalTypeEnum.FREE_WRITE_CANCEL_SIGNATURE),
    );
  },
  openFreeWriteSignatureCancelSurveyModal() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.openModal(ModalTypeEnum.FREE_WRITE_CANCEL_SIGNATURE_SURVEY),
    );
  },
  openFreeWriteRequireSignatureModal() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.openModal(ModalTypeEnum.FREE_WRITE_REQUIRE_SIGNATURE),
    );
  },
  openFreeWriteSignatureReminderModal() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.openModal(ModalTypeEnum.FREE_WRITE_SIGNATURE_REMINDER),
    );
  },
  selectEfileState(val) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.selectState(val),
    );
  },
  openFreeWriteUploadLoadingModal() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.openModal(ModalTypeEnum.FREE_WRITE_UPLOAD_LOADING),
    );
  },
  closeFreeWriteUploadLoadingModal() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.closeModal(ModalTypeEnum.FREE_WRITE_UPLOAD_LOADING),
    );
  },
  openFreeWriteUploadReadyModal() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.openModal(ModalTypeEnum.FREE_WRITE_UPLOAD_READY),
    );
  },
  openStaticFinishLaterModal() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.openModal(ModalTypeEnum.STATIC_FINISH_LATER),
    );
  },
  setFreeWriteUploadReadyRedirectURL(redirectURL, documentType, sessionHash, sessionKey) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.setUploadRedirectURL(
        redirectURL,
        documentType,
        sessionHash,
        sessionKey,
      ),
    );
  },
  setStaticBuilderNavStep(step) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.setStaticBuilderNavStep(step),
    );
  },
  saveFreeWriteContent() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.saveFreeWriteContent(),
    );
  },
  startFreeWriteAutoSave() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.startFreeWriteAutoSave(),
    );
  },
  stopFreeWriteAutoSave() {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.stopAutoSave(),
    );
  },
  editPDFPagesSetPagesFromFile(file) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.setPagesFromFile(file),
    );
  },
  getStaticBuilderCurrentStep() {
    const state = window.FormSwift.React.store.getState();
    return state.StaticBuilderReducer.step;
  },
  setStaticBuilderStepHistory(stepHistory) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.setStaticBuilderStepHistory(stepHistory),
    );
  },
  getStaticBuilderSectionKeys() {
    return window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.getStaticBuilderSectionKeys(),
    );
  },
  setStaticBuilderSectionKeys(keys) {
    return window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.setStaticBuilderSectionKeys(keys),
    );
  },
  setStaticBuilderSaveProgressBarAnimationStep(step) {
    return window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.setStaticBuilderSaveProgressBarAnimationStep(step),
    );
  },
  startStaticBuilderSaveProgressBarAnimation() {
    return window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.startStaticBuilderSaveProgressBarAnimation(),
    );
  },
  finishStaticBuilderSaveProgressBarAnimation() {
    return window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.finishStaticBuilderSaveProgressBarAnimation(),
    );
  },
  disableStaticBuilderSaveProgressBarAnimation() {
    return window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.disableStaticBuilderSaveProgressBarAnimation(),
    );
  },
  loadDocumentContent(documentContent) {
    return window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.loadDocumentContent(documentContent),
    );
  },
  saveStaticBuilderSectionContent(
    sectionContent,
    sectionStep,
    sectionTitle,
    sessionId,
    sessionHash,
    nextStepEnabled,
    successAction,
  ) {
    return window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.saveStaticBuilderSectionContent(
        sectionContent,
        sectionStep,
        sectionTitle,
        sessionId,
        sessionHash,
        nextStepEnabled,
        successAction,
      ),
    );
  },
  addStaticBuilderOnSectionLoadAction(onSectionLoadAction) {
    return window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.addStaticBuilderOnSectionLoadAction(onSectionLoadAction),
    );
  },
  loadNextStaticBuilderSection(skipSection) {
    return window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.loadNextStaticBuilderSection(skipSection),
    );
  },
  loadStaticBuilderSection(sectionStep) {
    return window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.loadStaticBuilderSection(sectionStep),
    );
  },
  enableRecipientSignature() {
    return window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.enableRecipientSignature(),
    );
  },
  setPopupAttachedToMouse(isAttached) {
    window.FormSwift.React.store.dispatch(
      window.FormSwift.React.actions.setPopupAttachedToMouse(isAttached),
    );
  },
  mainContainerHeightAdjusted(newHeight) {
    const mainContainerHeightAdjusted =
      getIn(window, 'FormSwift', 'React', 'actions', 'mainContainerHeightAdjusted');
    if (mainContainerHeightAdjusted) {
      window.FormSwift.React.store.dispatch(mainContainerHeightAdjusted(newHeight));
    }
  },
};
module.exports = ReactCompatibility;



// WEBPACK FOOTER //
// ./src-assets/js/react-compatibility.js